function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import AccordionComponent from "@demant/product-experience-page/lib/visual-oticon/modules/PEP-accordion/js/PEP-accordion";
var ImageSpotAccordionComponent = function ImageSpotAccordionComponent(_ref) {
  var settings = _ref.settings;
  var findAccordionData = function findAccordionData() {
    var accordionDataArr = [];
    settings.elements.map(function (element) {
      var accordionObj = {};
      if (element.contextContent) {
        var doc = new DOMParser().parseFromString(element.contextContent, 'text/html');
        var headline = doc.querySelector('h1, h2, h3, h4, h5, h6').innerText;
        var description = doc.querySelector('div, p, span').outerHTML;
        var additionalDescription = doc.querySelectorAll('p, span').length > 1 ? doc.querySelectorAll('p, span')[1].outerHTML : null;
        accordionObj[headline] = [];
        accordionObj[headline].push({
          description: description,
          additionalDescription: additionalDescription
        });
        accordionDataArr.push(accordionObj);
      } else {
        accordionDataArr.push(null);
      }
    });
    return accordionDataArr;
  };
  var _useState = useState(findAccordionData()),
    _useState2 = _slicedToArray(_useState, 1),
    accordionData = _useState2[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, settings.elements.map(function (elem, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "image-spot-accordion"
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-spot-accordion__column image-container"
    }, elem.image && elem.image.src && /*#__PURE__*/React.createElement("div", {
      className: "image-spot-accordion__column__image",
      style: {
        backgroundImage: "url(".concat(elem.image.src, ")")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "image-spot-accordion__column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-spot-accordion__column__info"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "image-spot-accordion__column__title",
      dangerouslySetInnerHTML: {
        __html: elem.header
      }
    }), /*#__PURE__*/React.createElement("p", {
      className: "image-spot-accordion__column_content",
      dangerouslySetInnerHTML: {
        __html: elem.text
      }
    }), elem.contextContent && accordionData[index] && Object.keys(accordionData[index]).map(function (item, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccordionComponent, {
        element: item,
        elementsObj: accordionData[index],
        currIndex: index,
        key: index,
        activeOnLoad: 10
      }), accordionData[index][item].additionalDescription && /*#__PURE__*/React.createElement("p", {
        className: "image-spot-accordion__column_content",
        key: index,
        dangerouslySetInnerHTML: {
          __html: accordionData[index].additionalDescription
        }
      }));
    }), elem.link && /*#__PURE__*/React.createElement("a", {
      className: "pep-button bg-m-magenta custom-hover",
      href: elem.link.href
    }, elem.link.content))));
  }));
};
export default ImageSpotAccordionComponent;